module.exports = __webpack_public_path__ + "img/tranquilidad.f0f9351f.svg";